import React from 'react';
import { IconButton } from '@mui/material';
import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri';

export interface Props {
	visible: boolean;
	onChange: (visible: boolean) => void;
	disabled?: boolean;
}
const EyeButton = (props: Props) => {
	const { visible, onChange, disabled } = props;
	return (
		<IconButton disabled={disabled} onClick={() => onChange(visible)}>
			{!visible && !disabled ? (
				<RiEyeFill size={16} color="secondary" />
			) : (
				<RiEyeOffFill size={16} color="secondary" />
			)}
		</IconButton>
	);
};

export default EyeButton;
